const ADRENAL_CONTRALATERAL = 'adrenalContralateral';

export default ADRENAL_CONTRALATERAL;
